import React,{useState,useRef} from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Header ,Modal} from '../../../../components';
import { Button, message, Input, BackTop } from 'antd';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { useModal } from 'react-modal-hook';
import  Table  from '../components/Table';
import  Form  from '../components/Form';
import CopySettingsModal from '../components/CopySettingsModal';
import { useFetchCompany,UseFetchCreateCompany,UseFetchUpdateCompany} from "../hooks/useFetch";

function Users() {
  const { currentColor } = useStateContext();
  const queryClient = useQueryClient();
  const [ dataEdit, setDataEdit] = useState(null);
  // บริษัทปลายทางของการคัดลอกการตั้งค่า (null = ปิด modal)
  const [ copyTarget, setCopyTarget] = useState(null);
  const { data:dataCompany, isLoading:isLoadingCompany ,refetch:refetchCompany } = useFetchCompany();
  const {  mutate: fetchUpdateCompany } = UseFetchUpdateCompany();
  const {  mutate: fetchCreateCompany } = UseFetchCreateCompany();

  // Navbar/Sidebar ใช้คนละ query key กับหน้านี้ ('getFetchCompanyForNavbar')
  // ถ้าไม่ล้างด้วย ชื่อ/สีบริษัทบนแถบเมนูจะยังเป็นของเก่าจนกว่าจะรีเฟรชหน้า
  const refreshCompanyEverywhere = () => {
    refetchCompany();
    queryClient.invalidateQueries(['getFetchCompanyForNavbar']);
  };

  const userId = sessionStorage.getItem('id')

  const titlePage = 'บริษัท';
  const formAddRef = useRef(null); 
  const formEditRef = useRef(null); 
  
  //#region usehook model
  const [showAddModal, hideAddModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formAddRef.current.validateFields();
        const payload = {
          ...value,
          userId:userId
        }
        
        var result = await fetchCreateCompany(payload)
        await message.destroy(); 
        await message.success('เพิ่มข้อมูลสำเร็จ');
        await hideAddModal();
        refreshCompanyEverywhere()  
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถเพิ่มข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
        
      }
    };

    return (
      <Modal
        title={`เพิ่ม ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideAddModal}
      >
        <Form formRef={formAddRef}/>
      </Modal>
    );
  }, []);

  const [showEditModal, hideEditModal] = useModal(() => {
    const handleOnOk = async (event) => {
      event.preventDefault();
      message.loading('กรุณารอซักครู่...', 0);
      try {
        const value =  await formEditRef.current.validateFields();
        console.log(value);
        
        const updateData = {...value,id:dataEdit.id,userId:userId}
        let result = await fetchUpdateCompany(updateData)

        await message.destroy(); 
        await message.success('แก้ไขขอมูลสำเร็จ');
        await hideEditModal();
        refreshCompanyEverywhere()
      } catch (error) {
        console.error('Error adding data:', error);
        message.error('ไม่สามารถแก้ไขข้อมูลได้'); 
        //await hideAddModal();
      } finally {
        await message.destroy(); 
      }
    };

    return (
      <Modal
        title={`แก้ไข ${titlePage}`}
        okText='ยืนยัน'
        cancelText='ยกเลิก'
        width={600}
        onOk={handleOnOk}
        onCancel={hideEditModal}
      >
        <Form formRef={formEditRef} initialValues={dataEdit}/>
      </Modal>
    );
  }, [dataEdit,isLoadingCompany]);
    //#endregion


  const handleEdit = (record) => {
     setDataEdit(record);
     showEditModal()
  }

  return (
    <div className="md:m-10">
      <div className="flex justify-between">
        <Header category="App" title={titlePage} />
        <Button onClick={showAddModal} className='bg-blue-500 text-white'>
          เพิ่ม
        </Button>
      </div>
      <Table data={dataCompany} onEdit={handleEdit} onCopySettings={setCopyTarget} loading={isLoadingCompany} bordered />
      <CopySettingsModal
        open={!!copyTarget}
        target={copyTarget}
        companies={dataCompany || []}
        onClose={() => setCopyTarget(null)}
      />
    </div>
  );
}

export default Users;
